import { render, staticRenderFns } from "./AboutApplyfor.vue?vue&type=template&id=f25bc6ec&scoped=true&"
import script from "./AboutApplyfor.vue?vue&type=script&lang=js&"
export * from "./AboutApplyfor.vue?vue&type=script&lang=js&"
import style0 from "./AboutApplyfor.vue?vue&type=style&index=0&id=f25bc6ec&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f25bc6ec",
  null
  
)

export default component.exports